import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Sends a renamed route to its new path with the same query string and hash,
 * so a saved or shared link still opens the same record. `<Navigate to>` with
 * a plain path drops `?id=`, which is the part that matters on a detail view.
 */
export const RedirectWithSearch: React.FC<{ to: string }> = ({ to }) => {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: to, search, hash }} replace />;
};
